(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ayfCoverageReady) return;
    root.dataset.ayfCoverageReady = 'true';
    var branches;
    try { branches = JSON.parse(root.querySelector('[data-ayf-branches]').textContent); } catch (e) { return; }
    var branchField = root.querySelector('[data-ayf-branch]');
    var barrioField = root.querySelector('[data-ayf-barrio]');
    var addressField = root.querySelector('[data-ayf-address]');
    var phoneField = root.querySelector('[data-ayf-phone]');
    var notesField = root.querySelector('[data-ayf-notes]');
    var ok = root.querySelector('[data-ayf-coverage-ok]');
    var off = root.querySelector('[data-ayf-coverage-off]');
    function selected() { return branches.find(function (branch) { return branch.id === branchField.value; }); }
    function barrios(branch) { return branch ? String(branch.barrios || '').split(/\r?\n/).map(function (v) { return v.trim(); }).filter(Boolean) : []; }
    function update() {
      var branch = selected();
      var barrio = barrioField.value;
      var allowed = branch && barrios(branch).indexOf(barrio) !== -1;
      ok.hidden = !allowed;
      off.hidden = !branch || !barrio || !!allowed;
      if (allowed) ok.textContent = 'Sede ' + branch.name + ' · entrega en ' + barrio + '. Domicilio calculado al pagar.';
      if (window.AYF) {
        window.AYF.setCustomer({branch: branch ? branch.id : '', branchName: branch ? branch.name : '', branchAddress: branch ? branch.address : '', barrio: allowed ? barrio : '', address: addressField.value, phone: phoneField.value, notes: notesField.value});
        window.AYF.setZone(allowed ? {id: branch.id, name: branch.name + ' · ' + barrio, fee: null, variantId: null} : null);
      }
    }
    function chooseBranch() {
      var branch = selected();
      barrioField.replaceChildren();
      barrioField.add(new Option(branch ? 'Selecciona el barrio de entrega' : 'Primero selecciona una sede', ''));
      barrioField.disabled = !branch;
      barrios(branch).forEach(function (barrio) { barrioField.add(new Option(barrio, barrio)); });
      if (branch) barrioField.add(new Option('Mi barrio no está en la lista', '__off__'));
      root.querySelector('[data-ayf-branch-info]').hidden = !branch;
      if (branch) {
        root.querySelector('[data-ayf-branch-name]').textContent = branch.name;
        root.querySelector('[data-ayf-branch-address]').textContent = branch.address;
        root.querySelector('[data-ayf-branch-map]').href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(branch.address);
      }
      update();
    }
    branchField.addEventListener('change', chooseBranch);
    barrioField.addEventListener('change', update);
    [addressField, phoneField, notesField].forEach(function (input) { input.addEventListener('input', update); });
    var saved = window.AYF ? Object.assign({}, window.AYF.getState().customer) : {};
    addressField.value = saved.address || ''; phoneField.value = saved.phone || ''; notesField.value = saved.notes || '';
    branchField.value = saved.branch || '';
    chooseBranch();
    if (barrios(selected()).indexOf(saved.barrio) !== -1) barrioField.value = saved.barrio;
    update();
    window.AYFCoverageSync = update;
  }
  function start() { document.querySelectorAll('[data-ayf-coverage]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
